// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import orgReducer from './orgSlice'; // Import org slice reducer
import currencyReducer from './currencySlice'; // Import currency slice reducer
import userDataReducer from './userDataSlice'; // Import currency slice reducer
import dashboardReducer from './dashboardSlice'; // Import user slice reducer (example)

export const store = configureStore({
  reducer: {
    org: orgReducer,
    currency: currencyReducer,
    userBasicInfo: userDataReducer,
    dashboard: dashboardReducer, // Add user reducer to the store (example)
  }
});


